
import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  collabItems,
  tagList,
  cardItems,
} from './values';

export const MktPlaceContext = createContext();

let handleSeachTimeOut = null;
const MktPlaceContextProvider = ({ children }) => {
  const [showModal, toggleShowModal] = useState(false);
  const [renderedCards, setRenderedCards] = useState(cardItems);

  const [filteredOptions, setFilteredOptions] = useState(tagList);
  const [filterTyped, setFilterTyped] = useState('');

  useEffect(() => {
    const itemsToBeRendered = cardItems.filter(card => card.show);
    setRenderedCards(itemsToBeRendered);
  }, []);


  const clearFilter = () => {
    const options = [...filteredOptions];
    options.map((option) => {
      const newOption = option;
      newOption.checked = false;
      return newOption;
    });
    options[0].checked = true;

    setFilteredOptions(options);
    setFilterTyped('');
  };

  useEffect(() => {
    clearTimeout(handleSeachTimeOut);
    handleSeachTimeOut = setTimeout(() => {
      if (cardItems.length && filteredOptions.length) {
        const shouldRenderAll = filteredOptions.find(filter => filter.value === 'all').checked;
        const activeOptions = filteredOptions.filter(filterOption => filterOption.checked);
        const optionFilteredSubscriptions = cardItems.filter((card) => {
          const shouldBeRendered = activeOptions.some(option => card.type.some(type => type === option.id));
          return shouldRenderAll || shouldBeRendered;
        });

        const filteredCards = optionFilteredSubscriptions.filter((subscription) => {
          if (!subscription.show) {
            return false;
          }
          const subscriptionString = JSON.stringify(subscription).toLowerCase();
          const filterTypedLower = filterTyped.toLowerCase();
          return subscriptionString.includes(filterTypedLower);
        });

        setRenderedCards(filteredCards);
      }
    }, 100);
  }, [filteredOptions, filterTyped]);


  const values = {
    filteredOptions,
    setFilteredOptions,
    filterTyped,
    setFilterTyped,
    clearFilter,
    cardItems,
    renderedCards,
    setRenderedCards,
    showModal,
    toggleShowModal,
    collabItems,
  };

  return (
    <MktPlaceContext.Provider value={values} t={key => key}>
      {children}
    </MktPlaceContext.Provider>
  );
};

MktPlaceContextProvider.propTypes = {
  children: PropTypes.node,
};

MktPlaceContextProvider.defaultProps = {
  children: null,
};

export default MktPlaceContextProvider;
